import { render, staticRenderFns } from "./template.html?vue&type=template&id=68f9a547&scoped=true&"
import script from "./HomeFavoritelistEn.vue?vue&type=script&lang=ts&"
export * from "./HomeFavoritelistEn.vue?vue&type=script&lang=ts&"
import style0 from "./HomeFavoritelistEn.vue?vue&type=style&index=0&id=68f9a547&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f9a547",
  null
  
)

export default component.exports